export default function(obj, key, attr) {
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    ...attr,
  });
}